import script from "./LocalApp.vue?vue&type=script&setup=true&lang=js"
export * from "./LocalApp.vue?vue&type=script&setup=true&lang=js"

import "./LocalApp.vue?vue&type=style&index=0&id=0524317a&lang=scss"
import "./LocalApp.vue?vue&type=style&index=1&id=0524317a&lang=css"

const __exports__ = script;

export default __exports__